import { css } from '@emotion/css'
import { spacing, breakpoint, zIndex, shorthandHelper, mediaQueryHelper, colors } from '@offerzen/pinata-shame'

import { navbarHeight } from '../Navbar'

export const mobileToolbarHeight = 45
export const toolbarHeight = 50

const styles = {
  wrapper: css({
    zIndex: zIndex.level7,
    boxSizing: 'border-box',
    backgroundColor: colors.white,
    borderBottom: `1px solid ${colors.mystic}`,
    padding: shorthandHelper([spacing.small, 0]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: mobileToolbarHeight,
    position: 'fixed',
    top: navbarHeight,
    left: 0,
    right: 0,

    [mediaQueryHelper(breakpoint.tablet)]: {
      position: 'static',
      height: toolbarHeight,
    },
  }),

  container: css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }),
}

export default styles
